import { css } from "@emotion/css";
import { PANEL_WIDTH } from "../../constants";

// Popover mode anchors to the bottom of the panel (Meridian has no fixed positioning).
export const popoverAnchorClass = css({ position: "fixed", bottom: 0, left: 0, width: PANEL_WIDTH });
